import { mapGetters } from 'vuex'

export const MIXIN_PTO_ANNULLED = {

  data: () => ({
    isShowAnnulled: false,
    annulledQueryKey: '',
    namespaced: ''
  }),

  computed: {
    ...mapGetters('pto/project', {
      getChildrenFilter: 'getChildrenFilter'
    }),
    initFilter () { 
      return {
        ...this.getChildrenFilter,
        [this.annulledQueryKey]: 'is_not_canceled'
      }
    }
  },
  methods: {
    showAnnulled () {
      this.isShowAnnulled = !this.isShowAnnulled
      this.$store.dispatch(this.namespaced + '/loadFilter', {
        ...this.getChildrenFilter,
        [this.annulledQueryKey]: this.isShowAnnulled ? null : 'is_not_canceled'
      })
    }
  }
}
